import React from 'react';

export function purchaseLineLabel(part) {
  const poNumber = part?.purchaseOrderNumber;
  if (!poNumber) return '-';
  const line = part.purchaseOrderLineNumber;
  return line ? `${poNumber}-${line}` : String(poNumber);
}

export function purchaseLinePath(part) {
  if (!part?.id) return null;
  return `/admin/purchases?purchasedPart=${encodeURIComponent(part.id)}`;
}

export function PurchaseLineLink({ part }) {
  const label = purchaseLineLabel(part);
  const path = purchaseLinePath(part);
  if (!path || label === '-') return label;
  return (
    <a
      className="po-line-link"
      href={path}
      title="Open this PO line. Ctrl+click opens Purchases in a new tab."
      onClick={(event) => event.stopPropagation()}
    >
      {label}
    </a>
  );
}
